import React from 'react';
import PropTypes from 'prop-types';
import Link from '../common/Link';
import DevelopmentItem from './DevelopmentItem';
import DevelopmentItemLoading from './DevelopmentItemLoading';

const Developments = ({ developments, error }) => {
  if (!developments && error) {
    return <p>An error occurred while trying to load developments, please try again later.</p>;
  }
  return (
    <div className="developments auto-clear row-flex row-flex-wrap">
      {developments
        ? developments.map((development) => (
            <DevelopmentItem key={development.id} {...development} />
          ))
        : [0, 1, 2].map((key) => <DevelopmentItemLoading key={key} />)}
    </div>
  );
};

Developments.propTypes = {
  developments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
    })
  ),
  error: PropTypes.string,
};

Developments.defaultProps = {
  error: undefined,
};

const NotFound = ({ search }) => (
  <div className="col-md-12">
    <p>No developments found{search && ' with your search query'}.</p>
    <p>
      Can{"'"}t find what you{"'"}re looking for{'?'} <Link to="forthcoming">Click here</Link> to
      view forthcoming developments.
    </p>
  </div>
);

NotFound.propTypes = {
  search: PropTypes.string,
};

NotFound.defaultProps = {
  search: undefined,
};

const DevelopmentItems = ({ developments, search, error }) => {
  if (developments && !developments.length) {
    return (
      <div className="container">
        <NotFound search={search} />
      </div>
    );
  }
  return (
    <section className="list container">
      <Developments developments={developments} error={error} />
    </section>
  );
};

DevelopmentItems.propTypes = {
  developments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
    })
  ),
  search: PropTypes.string,
  error: PropTypes.string,
};

DevelopmentItems.defaultProps = {
  search: undefined,
  error: undefined,
};

export default DevelopmentItems;
